<template>
  <div class="nft_wrapper nft_log" id="myNft">
    <!-- title -->
    <div class="main_top">
      <h1>
        <img src="images/basic/icon/back.svg" onclick="history.back()" class="back" />
        NFT 포인트 적립 내역
      </h1>
      <a class="h1_div"> </a>
    </div>
    <div class="div_padding"></div>
    <div class="act_div">
      <div class="list">
        <div class="act_list get" v-for="(history,index) in resultList" :key="index">
          <div class="act_icon"><img src="images/basic/icon/act-point.svg" alt=""></div>
          <div class="text">
            <p>{{history.nftSn}}</p>
            <p>{{history.pointRegDate}}</p>
          </div>
        
          <span class="get_rate">+{{history.pointAmountView}}</span>
        </div>
        <!--
        <div class="act_list get">
          <div class="act_icon"><img src="images/basic/icon/act-point.svg" alt=""></div>
          <p>광고보상 포인트 획득</p>
          <span class="get_rate">+30</span>
        </div>
        <div class="act_list spend">
          <div class="act_icon" ><img src="images/basic/icon/act-point.svg" alt=""></div>
          <p>포인트를 TRX로 환전</p>
          <span class="send_rate">-500000</span>
        </div>
       <div class="act_list get">
          <div class="act_icon"><img src="images/basic/icon/act-point.svg" alt=""></div>
          <p>광고보상 포인트 획득</p>
          <span class="get_rate">+30</span>
        </div>
        <div class="act_list get">
          <div class="act_icon"><img src="images/basic/icon/act-point.svg" alt=""></div>
          <p>광고보상 포인트 획득</p>
          <span class="get_rate">+400</span>
        </div>
        -->
    </div>
  </div>
  </div>
</template>

<script>
import $ from 'jquery'
import { fetchPointList } from "@/api/nft";
export default {
  data() {
     return{
        resultList:[],
        pageIndex:1,
        recordCntOnPage:20
     }
  },
  created() {
   this.getPointList();
  },
  mounted() {
    var offset = 10;
    window.addEventListener("scroll", () => {
      // scroll event 등록
      if (window.$(window).scrollTop() > ( window.$(document).height() - window.$(window).height()) -offset) {
        this.getPointList();
      }
    });
  },
   methods: {
    getPointList() {
      var request = {
        pageIndex:this.pageIndex++,
        recordCntOnPage :this.recordCntOnPage 
      }
      fetchPointList(request)
        .then(({ data }) => {
          this.resultList = [...this.resultList, ...data.resultList];
        })
    },
   }
}
</script>

<style scoped>

</style>
